import useIsMobile from '../../../../modules/hooks/common/useIsMobile'

/**
 * 부분 하이라이트
 */
interface IHighlightedTitleProps {
  title: string | number
  color: string //hex color
  disabled?: boolean
  size?: number
}
const HighlightedTitle = ({ title, color, disabled = false, size = 16 }: IHighlightedTitleProps) => {
  const spiltTitle = typeof title === 'string' && title.indexOf('|') !== -1 ? title?.split('|') : title
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <p className="relative">
        {typeof title === 'string' && title.indexOf('|') !== -1 ? (
          <>
            <span
              className={
                disabled
                  ? `text-sTitle box-decoration-clone font-bold text-gray-500 underline decoration-8 underline-offset-[-4px]`
                  : `text-sTitle box-decoration-clone font-bold text-black underline decoration-8 underline-offset-[-4px]`
              }
              style={{
                textDecorationSkipInk: 'none',
                textDecorationColor: color,
              }}
            >
              {spiltTitle[0]}
            </span>
            <span className={disabled ? 'text-sTitle font-bold text-gray-500' : 'text-sTitle font-bold text-black'}>
              {spiltTitle[1]}
            </span>
          </>
        ) : (
          <span className={disabled ? 'text-sTitle font-bold text-gray-500' : 'text-sTitle font-bold text-black'}>
            {title}
          </span>
        )}
      </p>
    )
  } else {
    return (
      <p className="relative">
        {typeof title === 'string' && title.indexOf('|') !== -1 ? (
          <>
            <span
              className={
                disabled
                  ? `text-[${size}px] font-bold text-gray-500`
                  : `text-[${size}px] bg-purple-50 box-decoration-clone font-bold text-black`
              }
            >
              {spiltTitle[0]}
            </span>
            <span
              className={
                disabled
                  ? `text-[${size}px] keep-all font-bold text-gray-500`
                  : `text-[${size}px] keep-all font-bold text-black`
              }
            >
              {spiltTitle[1]}
            </span>
          </>
        ) : (
          <span
            className={disabled ? `text-[${size}px] font-bold text-gray-500` : `text-[${size}px] font-bold text-black`}
          >
            {title}
          </span>
        )}
      </p>
    )
  }
}

export default HighlightedTitle
